import React from 'react';
import PropTypes from 'prop-types';
import { PostHogProvider } from '@posthog/react';
import { CONSENT_ACCEPTED, CONSENT_EVENT, getStoredConsent } from './consent';
import {
  initializePostHog,
  applyPostHogConsent,
  revokePostHogConsent,
} from './posthog';
import { loadGoogleAnalytics, disableGoogleAnalytics } from './googleAnalytics';

const AnalyticsProvider = ({ children }) => {
  const client = initializePostHog();
  const [consent, setConsent] = React.useState(getStoredConsent);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleConsentChange = (event) => {
      if (event.detail?.revoked) {
        revokePostHogConsent();
      }
      setConsent(event.detail?.choice ?? getStoredConsent());
    };

    window.addEventListener(CONSENT_EVENT, handleConsentChange);
    return () => window.removeEventListener(CONSENT_EVENT, handleConsentChange);
  }, []);

  React.useEffect(() => {
    applyPostHogConsent(consent);

    if (consent === CONSENT_ACCEPTED) {
      loadGoogleAnalytics();
    } else {
      disableGoogleAnalytics();
    }
  }, [consent]);

  if (!client) {
    return children;
  }

  return <PostHogProvider client={client}>{children}</PostHogProvider>;
};

AnalyticsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AnalyticsProvider;
